import React from 'react';
import ProjectDetail from './ProjectDetail';
import { projectMeta } from './data';
import ProgressiveImg from '../components/ProgressiveImg';
import Figure from '../components/Figure';
import { toCdn } from '../utils/cdn';

export default function ABCFinder() {
  const meta = projectMeta.abc;
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role} url={meta.url}>
      {/* Custom per-project content goes here */}

      <p>ABC Finder began as an experiment with CoreML and YOLOv3 object recognition. The model worked so well that I decided to build an educational app.</p>

      <p>The app creates a scavenger hunt where kids search for objects around the house using the camera. When they find something, the app reads the word and identifies the starting letter.</p>

      <p>After testing with my son and refining the object detection, I launched it on the App Store. It was a great way to explore Core ML while building something useful.</p>

      <div className="media-gallery">

        <Figure caption="Demo Video">
          <div className="video-mask">
            <video
              src={toCdn('/images/projects/abcfinder/abcfinder.mp4')}
              poster={toCdn('/images/projects/abcfinder/abcfinder_poster.webp')}
              alt="Demo Video"
              className="gallery-item"
              loading="lazy"
              controls
            />
          </div>
        </Figure>

        <Figure caption="Screenshots">
          <ProgressiveImg
            src={toCdn('/images/projects/abcfinder/abcfinder_1.webp')}
            alt="Screenshots"
            className="gallery-item"
          />
        </Figure>

        <Figure caption="Website">
          <ProgressiveImg
            src={toCdn('/images/projects/abcfinder/abcfinder_2.webp')}
            alt="Website"
            className="gallery-item"
          />
        </Figure>

      </div>
    </ProjectDetail>
  );
}
